export default "__VITE_ASSET__BxQ0AP1S__"